// @flow
import React, {Component} from 'react';
import CrumbName from './CrumbName';
import LinkedCrumb from './LinkedCrumb';

import type {BreadcrumbShape} from '../../queries/searchQuery';

import './Breadcrumbs.less';

type BreadCrumbsProps = {
    ariaLabel: string,
    crumbs: BreadcrumbShape[],
    isLastCrumbLinked: boolean,
    // flow doesn't understand that Function.prototype is a Function type.
    onClickCrumbName: any
};

/**
 * This is @homeaway/react-breadcrumbs 3.0. We can't use the official breadcrumbs because we have two sets of crumbs on the page.
 */
class Breadcrumbs extends Component<BreadCrumbsProps> {
    static defaultProps = {
        ariaLabel: 'You are here:',
        crumbs: [],
        onClickCrumbName: Function.prototype
    };

    handleCrumbNameClick(crumb: any) {
        return (event: any) => {
            this.props.onClickCrumbName(event, crumb);
        };
    }

    render() {
        const {ariaLabel, crumbs, isLastCrumbLinked, ...rest} = this.props;
        const crumbsLength = crumbs.length;
        const hasCrumbs = crumbsLength > 0;
        const lastCrumb = crumbs[crumbsLength - 1];
        delete rest.onClickCrumbName;

        return (
            <nav aria-label={ariaLabel} {...rest}>
                {hasCrumbs && (
                    <ol className="Breadcrumb">
                        {crumbs
                            .filter(
                                (crumb) =>
                                    isLastCrumbLinked || crumb !== lastCrumb
                            )
                            .map((crumb, index) => (
                                <LinkedCrumb
                                    key={index}
                                    hasDivider={index !== crumbsLength - 1}
                                    currentPage={index === crumbsLength - 1}
                                    onClickName={this.handleCrumbNameClick(
                                        crumb
                                    )}
                                    url={crumb.url}
                                    name={crumb.name}
                                    position={index + 1}
                                />
                            ))}
                        {!isLastCrumbLinked && (
                            <li className="Breadcrumb__li Breadcrumb__li--active">
                                <CrumbName name={lastCrumb.name} />
                                <span content={crumbsLength} aria-hidden />
                            </li>
                        )}
                    </ol>
                )}
            </nav>
        );
    }
}

export default Breadcrumbs;
